import { queryOptions, useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";

import type { QueryConfig } from "@/lib/react-query";
import type { List } from "@/types/entity";
import type { Garage } from "@/types/garage";

export const getGarages = async (page = 1): Promise<List<Garage>> => {
  return (await api.get("/carburate/garages/", { params: { page } })) as List<Garage>;
};

export const getGaragesQueryOptions = ({ page }: { page?: number } = {}) => {
  return queryOptions({
    queryKey: page ? ["garages", { page }] : ["garages"],
    queryFn: () => getGarages(page),
    staleTime: 0,
    gcTime: 0,
  });
};

type UseGaragesOptions = {
  queryConfig?: QueryConfig<typeof getGarages>;
};

export const useGarages = ({ queryConfig }: UseGaragesOptions = {}) => {
  return useQuery({
    enabled: hasAccessToken(),
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    ...getGaragesQueryOptions(),
    ...queryConfig,
  });
};
